<template>
  <div id="contacto" class="appointment-wrap style2 ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <h2>Solicita una Llamada y Descubre Cómo Podemos Ayudarte</h2>
            <p>
              Nuestro equipo se traslada directamente a tu empresa para brindarte la mejor atención. Agenda una llamada y te explicaremos todos los beneficios que podemos ofrecer.
            </p>
          </div>
        </div>
      </div>

      <div class="row gx-5 align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="appointment-bg-one">
            <img src="../../assets/images/appointment-bg-1.jpg" alt="Image" />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="200"
        >
          <div class="book-appointment style2">
            <h5>Agenda una llamada personalizada</h5>
            <form action="https://opticlickbenichy.com/SendMail.php" method="POST" id="form-contact">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input name="nombre" type="text" placeholder="Nombre completo" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input name="correo" type="email" placeholder="Correo electrónico" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input name="telefono" type="number" placeholder="Número de teléfono" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input name="empresa" type="text" placeholder="Nombre de la empresa" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <textarea
                      name="message"
                      id="message"
                      cols="30"
                      rows="5"
                      placeholder="Déjanos un mensaje o consulta específica"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <input name="control" type="text" placeholder="" class="d-none" />
                  <button type="button" class="btn style2" id="btn-send-mail" @click="validateAndSubmit">
                    Solicitar Llamada
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookAppointment",
  methods: {
    validateAndSubmit() {
      const form = document.getElementById('form-contact');
      const btn = document.getElementById('btn-send-mail');
      const fields = [
        form.querySelector('input[name="nombre"]'),
        form.querySelector('input[name="correo"]'),
        form.querySelector('input[name="telefono"]'),
        form.querySelector('input[name="empresa"]'),
        form.querySelector('textarea[name="message"]')
      ];
      let valid = true;
      fields.forEach(field => {
        if (!field.value.trim()) {
          field.classList.add('input-error');
          valid = false;
        } else {
          field.classList.remove('input-error');
        }
      });
      if (!valid) {
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Enviando...';
      form.submit();
    }
  }
};
</script>

<style scoped>
.input-error {
  border: 1px solid red !important;
}
</style>
